import AsyncCreatableSelect from 'react-select/async-creatable';
import createSelect from './createSelect';
export default createSelect(AsyncCreatableSelect);